/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDtoTimeZoneRulesTransitionsInnerDuration } from './PartnerStationDtoTimeZoneRulesTransitionsInnerDuration';
import {
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionsInnerDurationToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionsInnerDuration';
import type { PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore } from './PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore';
import {
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore';

/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRulesTransitionsInner
 */
export interface PartnerStationDtoTimeZoneRulesTransitionsInner {
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    offsetBefore?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    offsetAfter?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerDuration}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    duration?: PartnerStationDtoTimeZoneRulesTransitionsInnerDuration;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    gap?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    dateTimeBefore?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    dateTimeAfter?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    overlap?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionsInner
     */
    instant?: Date;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRulesTransitionsInner interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRulesTransitionsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSON(json: any): PartnerStationDtoTimeZoneRulesTransitionsInner {
    return PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRulesTransitionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offsetBefore': !exists(json, 'offsetBefore') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json['offsetBefore']),
        'offsetAfter': !exists(json, 'offsetAfter') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json['offsetAfter']),
        'duration': !exists(json, 'duration') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerDurationFromJSON(json['duration']),
        'gap': !exists(json, 'gap') ? undefined : json['gap'],
        'dateTimeBefore': !exists(json, 'dateTimeBefore') ? undefined : (new Date(json['dateTimeBefore'])),
        'dateTimeAfter': !exists(json, 'dateTimeAfter') ? undefined : (new Date(json['dateTimeAfter'])),
        'overlap': !exists(json, 'overlap') ? undefined : json['overlap'],
        'instant': !exists(json, 'instant') ? undefined : (new Date(json['instant'])),
    };
}

export function PartnerStationDtoTimeZoneRulesTransitionsInnerToJSON(value?: PartnerStationDtoTimeZoneRulesTransitionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offsetBefore': PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value.offsetBefore),
        'offsetAfter': PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value.offsetAfter),
        'duration': PartnerStationDtoTimeZoneRulesTransitionsInnerDurationToJSON(value.duration),
        'gap': value.gap,
        'dateTimeBefore': value.dateTimeBefore === undefined ? undefined : (value.dateTimeBefore.toISOString()),
        'dateTimeAfter': value.dateTimeAfter === undefined ? undefined : (value.dateTimeAfter.toISOString()),
        'overlap': value.overlap,
        'instant': value.instant === undefined ? undefined : (value.instant.toISOString()),
    };
}

